import { resources } from "@constants/hardcoded-strings";
import { QueryParameter } from "@idw-types/common";
import { WorkflowReportSearchResultsTypes } from "@idw-types/state/workflow-report-state";
import {
    setPartialWorkflowReportSearchResultsLoading,
    setWorkflowReportSearchResultsStepByStep
} from "@redux/actions/workflow-report-actions";
import { getWorkflowReportStepByStepRequest } from "@requests/reports/get-workflow-report-step-by-step";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { Dispatch } from "redux";

export const getWorkflowReportSearchResultsStepByStepReduxRequest = (dispatch: Dispatch) => async (
    queryParameters: Array<QueryParameter> 
) => {
    dispatch(setPartialWorkflowReportSearchResultsLoading(true, WorkflowReportSearchResultsTypes.stepByStep));

    const { data: stepByStepData, error: stepByStepError } = await getWorkflowReportStepByStepRequest(queryParameters);

    if (stepByStepData) {
        dispatch(setWorkflowReportSearchResultsStepByStep(stepByStepData));

    } else {
        if (stepByStepError) {
            logAndDisplayErrorModal(
                dispatch,
                stepByStepData,
                resources.requests.getWorkflowReportStepByStep.error.title,
                resources.requests.getWorkflowReportStepByStep.error.message,
                null,
                queryParameters
            );
        }
        dispatch(setPartialWorkflowReportSearchResultsLoading(false, WorkflowReportSearchResultsTypes.stepByStep));
    }
};